import clarity from "@microsoft/clarity";

export const initClarity = (projectId) => {
  console.log('initClarity')
clarity.init("pxxaer3wi3");
console.log('clarity', clarity)

}; 